import { getCssColorVariable } from "./Utility";

export const getChartColors = (monochrome: boolean = false): string[][] => {
  if (monochrome) return [[getCssColorVariable("--color-primary-500")], [getCssColorVariable("--color-primary-300")]];
  return [
    [
      getCssColorVariable("--color-primary-500"),
      getCssColorVariable("--color-secondary-500"),
      getCssColorVariable("--color-info-500"),
      getCssColorVariable("--color-help-500"),
      getCssColorVariable("--color-success-500"),
      getCssColorVariable("--color-warning-500"),
      getCssColorVariable("--color-danger-500"),
    ],
    [
      getCssColorVariable("--color-primary-300"),
      getCssColorVariable("--color-secondary-300"),
      getCssColorVariable("--color-info-300"),
      getCssColorVariable("--color-help-300"),
      getCssColorVariable("--color-success-300"),
      getCssColorVariable("--color-warning-300"),
      getCssColorVariable("--color-danger-300"),
    ],
  ];
};

export const getFormattedData = (value: any, colors: string[][], index: number): void => {
  const normalColor = colors[0][index % colors[0].length];
  const emphasisColor = colors[1][index % colors[1].length];

  value.itemStyle = {
    color: normalColor,
  };
  let emphasis: any = {};
  emphasis.itemStyle = { color: emphasisColor };

  if (value.type === "line") {
    value.lineStyle = {
      color: normalColor,
      width: 3,
    };
    if (value.showArea != null && value.showArea) {
      value.areaStyle = {
        color: normalColor,
        opacity: 0.5,
      };

      emphasis.areaStyle = {
        color: emphasisColor,
        opacity: 0.5,
      };
    }

    emphasis.lineStyle = {
      color: emphasisColor,
    };
    emphasis.scale = 1.75;
  }

  value.emphasis = emphasis;
  value.animationDuration = 1500;
  value.animationEasing = "quadraticOut";

  return value;
};
